<template>
  <div class="otb-calendar-period" :class="requestClass">
    <label
      v-if="timeOptions && timeOptions.length"
      class="otb-calendar-period__label wb-type-copy-strong"
    >
      {{ timeOptionsLabel }}
      <wb-tooltip-host
        position="top"
        class="otb-calendar-period__label__tooltip otb-calendar-period__label__tooltip--no-margin"
      >
        <wb-icon
          name="bds/info-circle/24"
          class="otb-calendar-period__label__tooltip__icon"
        />
        <wb-tooltip>
          {{ $t('schedule.timeSlot.tooltip') }}
        </wb-tooltip>
      </wb-tooltip-host>
    </label>
    <div
      role="radiogroup"
      ref="calendarPeriodWrapper"
      class="otb-calendar-period__item-wrapper"
      :class="[itemWrapperLongClass, itemWrapperBookingMode]"
    >
      <calendar-period-item
        v-for="(option, index) in timeOptions"
        :key="`calendar-period-item-${index}`"
        :option="option"
        :index="index"
        :requestMode="requestMode"
        @input="input"
        v-model="slot"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';

import { CalendarPeriodOption } from '../../models/entities/calendar.model';

import useCalendarPeriod from '../../composables/calendar-period.composable';
import { useMediaQuery } from '../../composables/media-query.composable';
import { SCREEN_HEIGHT_SIZE } from '../../models/constants';

import { i18n } from '../../services/translation.service';

export default defineComponent({
  i18n,
  name: 'otb-calendar-period',
  components: {
    CalendarPeriodItem: () => import('../calendar-period-item/index.vue'),
  },
  props: {
    requestMode: Boolean,
    isMobile: Boolean,
    selectedSlot: Object as () => CalendarPeriodOption,
    timeOptions: Array as () => CalendarPeriodOption[],
    timeOptionsLabel: String,
  },
  setup(props, { emit }) {
    const CalendarPeriod = useCalendarPeriod(props, { emit });
    const { heightLessThan } = useMediaQuery();
    const requestClass = computed(() => {
      return props.requestMode ? 'otb-calendar-period__request' : '';
    });

    const input = (val: any) => {
      emit('selectedSlot', val);
    };

    const itemWrapperLongClass = computed(() => {
      return {
        'otb-calendar-period__item-wrapper__long': !heightLessThan(
          SCREEN_HEIGHT_SIZE.SMALL
        ),
      };
    });
    const itemWrapperBookingMode = computed(() => {
      return !props.requestMode
        ? 'otb-calendar-period__item-wrapper-booking'
        : '';
    });
    return {
      requestClass,
      ...CalendarPeriod,
      input,
      heightLessThan,
      itemWrapperLongClass,
      itemWrapperBookingMode,
    };
  },
});
</script>
<style src="./calendar-period.scss" lang="scss"></style>
